/**
 * GSAP animations for hhm-cards block: scroll-triggered header + staggered cards, hover lift.
 */
(function () {
	'use strict';

	function init() {
		if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
			return;
		}
		gsap.registerPlugin(ScrollTrigger);

		const section = document.querySelector('.hhm-cards-section');
		if (!section) return;

		const easeSnappy = 'power2.out';

		// ----- 1. Header: badge, title, description — staggered reveal on scroll -----
		const header = section.querySelector('.hhm-cards-header');
		if (header) {
			const badge = header.querySelector('.hhm-cards-header__badge');
			const title = header.querySelector('.hhm-cards-header__title');
			const desc = header.querySelector('.hhm-cards-header__desc');
			const headerEls = [badge, title, desc].filter(Boolean);

			if (headerEls.length) {
				gsap.set(headerEls, { opacity: 0, y: 24 });
				gsap.to(headerEls, {
					opacity: 1,
					y: 0,
					duration: 0.6,
					stagger: 0.1,
					ease: easeSnappy,
					scrollTrigger: {
						trigger: header,
						start: 'top 88%',
						toggleActions: 'play none none none',
					},
				});
			}
		}

		// ----- 2. Cards: staggered fade + slide up when section enters view -----
		const cards = section.querySelectorAll('.hhm-cards-card');
		if (cards.length) {
			gsap.set(cards, { opacity: 0, y: 40 });
			gsap.to(cards, {
				opacity: 1,
				y: 0,
				duration: 0.65,
				stagger: 0.1,
				ease: easeSnappy,
				scrollTrigger: {
					trigger: section,
					start: 'top 82%',
					toggleActions: 'play none none none',
				},
			});
		}

		// ----- 3. Card hover: subtle scale + shadow (GSAP for smooth feel) -----
		cards.forEach(function (card) {
			card.addEventListener('mouseenter', function () {
				gsap.to(card, {
					scale: 1.02,
					boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
					duration: 0.35,
					ease: easeSnappy,
				});
			});
			card.addEventListener('mouseleave', function () {
				gsap.to(card, {
					scale: 1,
					boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
					duration: 0.4,
					ease: easeSnappy,
				});
			});
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
